import React from 'react'
import { Toaster, ToasterProps } from 'react-hot-toast'

import { IconChracters1, IconCharacters5 } from '../../General'

export const Toast = ({ toastOptions, ...props }: ToasterProps) => {
  return React.cloneElement<ToasterProps>(<Toaster />, {
    position: 'top-center',
    toastOptions: {
      success: {
        icon: <IconChracters1 className="text-[32px]" />,
        className:
          'text-md font-bold !p-[15px] border border-success !text-success',
      },
      error: {
        icon: <IconCharacters5 className="text-[32px]" />,
        className:
          'text-md font-bold !p-[15px] border border-error !text-error',
      },
      custom: {
        duration: 4000,
      },
      ...toastOptions,
    },
    ...props,
  })
}
